import React, { useEffect, useRef } from "react";
import Theme from "../../../vars/ThemeOptions";
import { Container, Row, Col } from "react-bootstrap";
import { FiHome } from "react-icons/fi";
import { WMKLink } from "wmk-lib";

const TopBar = ({ topLink, setTopBarHeight }) => {
  const { title, url, target } = topLink;
  const topRef = useRef();
  useEffect(() => {
    setTopBarHeight(topRef.current.offsetHeight);
  }, [setTopBarHeight]);
  return (
    <Container
      className="top-bar"
      style={{ background: Theme.hex("navy"), margin: 0, padding: "0 2vh" }}
      fluid
      ref={topRef}
    >
      <Row style={{ margin: 0 }}>
        <Col
          style={{
            padding: "1vh 4vh",
            fontSize: ".95rem",
            lineHeight: 1,
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <WMKLink
            to={url}
            target={target}
            style={{ color: Theme.hex("reverse"), display: "flex" }}
          >
            {title} |{" "}
            <span
              style={{
                padding: "0 .25rem",
                display: "block",
                fontSize: ".875rem",
              }}
            >
              <FiHome />
            </span>
          </WMKLink>
        </Col>
      </Row>
    </Container>
  );
};

export default TopBar;
